import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1ae1dd63")

_pushScopeId("data-v-1ae1dd63")
const _hoisted_1 = {
  class: "navbar is-fixed-top",
  role: "navigation",
  "aria-label": "main navigation"
}
const _hoisted_2 = { class: "navbar-brand" }
const _hoisted_3 = /*#__PURE__*/_createVNode("a", { class: "navbar-item" }, [
  /*#__PURE__*/_createVNode("img", { src: "/Logo.png" })
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, null, -1)
const _hoisted_7 = { class: "navbar-end" }
const _hoisted_8 = { class: "navbar-item fix-right is-flex is-justify-content-flex-end" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 1,
  class: "buttons"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Learn ")
const _hoisted_12 = /*#__PURE__*/_createVNode("strong", null, "Sign up", -1)
const _hoisted_13 = {
  key: 2,
  class: "is-flex is-justify-content-flex-end"
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Learn ")
const _hoisted_15 = /*#__PURE__*/_createVNode("i", { class: "far fa-envelope" }, null, -1)
const _hoisted_16 = { class: "dropdown-trigger" }
const _hoisted_17 = {
  key: 0,
  class: "dropdown-menu",
  id: "dropdown-menu",
  role: "menu"
}
const _hoisted_18 = { class: "dropdown-content dropdown-box-position" }
const _hoisted_19 = { class: "has-text-centered" }
const _hoisted_20 = { class: "has-text-centered has-text-weight-normal email-margin" }
const _hoisted_21 = /*#__PURE__*/_createVNode("img", {
  src: "/img/navbar/manage_profile.svg",
  class: "margin-right-icone",
  "data-testid": "navbar-profile-button"
}, null, -1)
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Manage profile ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")
  const _component_popup = _resolveComponent("popup")

  return (_openBlock(), _createBlock("div", {
    class: `dropdown display-unset ${_ctx.dropdownIsActive} popup`
  }, [
    _createVNode("nav", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withId(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode("a", {
          role: "button",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleIsActive && _ctx.toggleIsActive(...args))),
          class: 
            `is-grey navbar-burger ${_ctx.isActive} ${
              _ctx.currentStep == 4 ? 'is-active' : ''
            }
            `
          ,
          "data-testid": "navbar-burger-button"
        }, [
          _hoisted_4,
          _hoisted_5,
          _hoisted_6
        ], 2)
      ]),
      _createVNode("div", {
        class: 
          `navbar-menu ${_ctx.isActive} ${_ctx.currentStep == 4 ? 'is-active' : ''}`
        
      }, [
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            (_ctx.loading)
              ? (_openBlock(), _createBlock("div", _hoisted_9))
              : (_ctx.user == null)
                ? (_openBlock(), _createBlock("div", _hoisted_10, [
                    _createVNode(_component_router_link, {
                      class: "button is-black is-small has-text-white ",
                      to: "/learn"
                    }, {
                      default: _withId(() => [
                        _hoisted_11
                      ]),
                      _: 1
                    }),
                    _createVNode("a", {
                      class: "button is-red is-small has-text-white ",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('toggle-sign-up'))),
                      "data-testid": "navbar-signup-button"
                    }, [
                      _hoisted_12
                    ]),
                    _createVNode("a", {
                      class: "button is-light is-small",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('toggle-login'))),
                      "data-testid": "navbar-login-button"
                    }, " Log in ")
                  ]))
                : (_ctx.user != null)
                  ? (_openBlock(), _createBlock("div", _hoisted_13, [
                      _createVNode(_component_router_link, {
                        class: "button is-black is-small has-text-white",
                        to: "/learn",
                        style: {"margin-right":"10px"},
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isActive = ''))
                      }, {
                        default: _withId(() => [
                          _hoisted_14
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_router_link, { to: "/inbox" }, {
                        default: _withId(() => [
                          _createVNode("a", {
                            class: "button is-small",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isActive = ''))
                          }, [
                            _hoisted_15
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode("div", _hoisted_16, [
                        _createVNode("a", {
                          onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.toggleDropdownIsActive()), ["stop"])),
                          class: "ml-2 is-small",
                          "aria-haspopup": "true",
                          "aria-controls": "dropdown-menu",
                          "data-testid": "navbar-avatar-button"
                        }, [
                          (_ctx.link != null)
                            ? (_openBlock(), _createBlock("img", {
                                key: 0,
                                src: _ctx.link,
                                class: "has-border-radius"
                              }, null, 8, ["src"]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
          ])
        ])
      ], 2),
      _createVNode(_component_popup, {
        position: "bottom",
        step: 4,
        offsetY: _ctx.windowWidth <= 768 ? 15 : 35,
        fixedX: '17px',
        showPopup: _ctx.currentStep == 4,
        offsetArrow: 32,
        onPrevAction: _ctx.prevAction,
        onNextAction: _ctx.nextAction
      }, null, 8, ["offsetY", "showPopup", "onPrevAction", "onNextAction"])
    ]),
    (_ctx.user != null)
      ? (_openBlock(), _createBlock("div", _hoisted_17, [
          _createVNode("div", _hoisted_18, [
            _createVNode("div", {
              class: "dropdown-box image dropdown-fixed-position is-flex is-flex-direction-column is-align-items-center",
              style: {
            marginTop: _ctx.windowWidth < 1024 ? '65px' : ''
          }
            }, [
              (_ctx.link != null)
                ? (_openBlock(), _createBlock("img", {
                    key: 0,
                    class: "is-rounded avatar-in-box",
                    src: _ctx.link
                  }, null, 8, ["src"]))
                : _createCommentVNode("", true),
              _createVNode("b", _hoisted_19, _toDisplayString(_ctx.user.username), 1),
              _createVNode("b", _hoisted_20, _toDisplayString(_ctx.user.email), 1),
              _createVNode(_component_router_link, { to: "/profile" }, {
                default: _withId(() => [
                  _createVNode("a", {
                    onClick: _cache[7] || (_cache[7] = ($event: any) => {
                {
                  _ctx.toggleDropdownIsActive();
                  _ctx.isActive = '';
                }
              }),
                    class: "button has-text-white manage-profile-button"
                  }, [
                    _hoisted_21,
                    _hoisted_22
                  ])
                ]),
                _: 1
              }),
              _createVNode("button", {
                class: "button is-primary is-outlined has-text-white sign-out-button",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
                "data-testid": "navbar-logout-button"
              }, " Sign out ")
            ], 4)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
})